import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataProviderService } from 'src/app/___LOGIC/__data/data-provider.service';
import { EditDialogComponent } from '../../__common/edit-dialog/edit-dialog.component';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';

interface ChecklistItem {
  checklist_id: string;
  name: string;
  id: string;
  item: string;
  description: string | null;
  completed: boolean;
  dueDate: string;
}

@Component({
  selector: 'app-my-project',
  templateUrl: './my-project.component.html',
  styleUrls: ['./my-project.component.css']
})
export class MyProjectComponent implements OnInit {
  checklists: { name: string, items: ChecklistItem[] }[] = [];
  importantDates: { title: string, date: string }[] = [];
  reminders: { text: string }[] = [];

  data;

  constructor(private dialog: MatDialog,private dataProvider: DataProviderService,private commonFunctions: FunctionsService) {
    this.loadChecklists();
  }

  ngOnInit(): void {
    
    this.loadImportantDates();
    this.loadReminders();
    
  }

  isUserLogged(){
    return this.commonFunctions.getSelectedClientId();
  }

  loadChecklists(): void {
    /* this.dataProvider.getThisClientInteractions(); */
    
    // Fetch checklists from the backend
    const data2 = [
      // Example data structure based on provided object
      {
        checklist_id: "4",
        name: "Solicitud Visado en Costa Rica",
        id: "71",
        item: "Formulario de solicitud de visado",
        description: null,
        completed: true,
        dueDate: "0000-00-00 00:00:00"
      },
      {
        checklist_id: "4",
        name: "Solicitud Visado en Costa Rica",
        id: "69",
        item: "Certificado de Antecedentes Penales",
        description: "Para cuando la duración de los estudios supere los seis meses y solo para mayores de edad...",
        completed: true,
        dueDate: "0000-00-00 00:00:00"
      }
    ];

/*     this.data = this.dataProvider.resolveDep();
    const grouped = this.data.records.reduce((acc, curr) => {
      const checklist = acc.find(cl => cl.name === curr.name);
      if (checklist) {
        checklist.items.push(curr);
      } else {
        acc.push({ name: curr.name, items: [curr] });
      }
      return acc;
    }, []);
    this.checklists = grouped; */

    // Process data to structure suitable for component
    
  }

  loadImportantDates(): void {
    // Fetch important dates from the backend or service
    this.importantDates = [
      { title: 'Visa Application Deadline', date: '2022-08-01' },
      { title: 'Course Start Date', date: '2022-09-01' }
    ];
  }

  loadReminders(): void {
    // Fetch reminders from the backend or service
    this.reminders = [
      { text: 'Complete visa application form' },
      { text: 'Schedule a health check-up' }
    ];
  }

  toggleCompleted(item: ChecklistItem): void {
    // Handle toggling of task completion status
    item.completed = !item.completed;
    // Update the backend or service with the new status
  }

  editTask(task: ChecklistItem): void {
    const dialogRef = this.dialog.open(EditDialogComponent, {
      width: '250px',
      data: { field: 'task', value: task }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Update task with new data
        Object.assign(task, result);
      }
    });
  }

  editDate(date: any): void {
    const dialogRef = this.dialog.open(EditDialogComponent, {
      width: '250px',
      data: { field: 'date', value: date }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Update date with new data
        Object.assign(date, result);
      }
    });
  }

  editReminder(reminder: any): void {
    const dialogRef = this.dialog.open(EditDialogComponent, {
      width: '250px',
      data: { field: 'reminder', value: reminder }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Update reminder with new data
        Object.assign(reminder, result);
      }
    });
  }

  addReminder(): void {
    const newReminder = { text: '' };
    this.reminders.push(newReminder);
    this.editReminder(newReminder);
  }
  

  handleCta(cardStatus){
    
  }
}
